module.exports = __webpack_public_path__ + "static/img/1.53f0c19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui3/1.png
// module id = JeSN
// module chunks = 1